import { createContext } from 'react';

const cityWorkbookContext = createContext();

export default cityWorkbookContext;
